import { get, post } from '@/utils/http'

export function get_model_tree (params) {
  return get({ url: '/service-insight/index_open/get_model_tree', params })
}
export function open_index_tree (params) {
  return get({ url: '/service-insight/index_open/open_index_tree', params })
}